import styled from 'styled-components';
import {device} from '../../../../../../utils/device';

export const SkipPan = styled.div`
  height: 520px;
  display: flex;
  flex-direction: column;
  @media ${device.mobileS} {
    height: 100%;
  }
`;
export const SkipPanHdr = styled.div`
  display: flex;
  margin-bottom: 30px;
  @media ${device.mobileS} {
    margin-bottom: 20px;
  }
`;
export const Heading = styled.h3`
  font-size: 32px;
  line-height: 40px;
  font-weight: 900;
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  span {
    width: 28px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
  }
  @media ${device.mobileS} {
    font-size: 22px;
    line-height: 28px;
    span {
      display: none;
    }
  }
`;
export const SubHeading = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #000;
  margin-bottom: 8px;
  span {
    font-weight: 700;
  }
  @media ${device.mobileS} {
    font-size: 14px;
  }
`;
export const SkipOptions = styled.ul`
  margin-top: 25px;
  margin-bottom: 70px;
  li {
    list-style-type: none;
    margin-bottom: 20px;
    p {
      margin-top: 2px;
    }
    :last-child {
      margin-bottom: 0;
    }
  }
  @media ${device.mobileS} {
  }
`;
export const SkipPanFtr = styled.div`
  margin-top: 25px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  li {
    list-style-type: none;
    margin-bottom: 20px;
    p {
      margin-top: 2px;
    }
    :last-child {
      margin-bottom: 0;
    }
  }
  .primaryBtn {
    width: 136px;
    margin-top: 0;
    height: 44px;
    margin-left: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 900;
    color: #ffffff;
    background: linear-gradient(111deg, #53b2fe 13.87%, #065af3 121.84%);
    box-shadow: 0px 1px 7px rgb(0 0 0 / 20%);
    border-radius: 4px;
    text-align: center;
    border: none;
    cursor: pointer;
    text-transform: uppercase;
  }
  @media ${device.mobileS} {
    margin-top: auto;
    margin-bottom: 30px;
    .primaryBtn {
      margin-left: 0;
      width: 100%;
    }
  }
`;
export const Info = styled.div`
  padding: 6px 12px;
  background-color: #fff1dd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .icon {
    width: 20px;
    flex-shrink: 0;
    margin-right: 10px;
  }
  p {
    font-size: 12px;
    line-height: 16px;
    color: #000;
    font-weight: 700;
  }
`;
export const OtherField = styled.div`
  padding-left: 30px;
  padding-top: 16px;
`;
export const ErrMsg = styled.p`
  font-size: 12px;
  line-height: 24px;
  color: #ef4d51;
  margin-top: 16px;
`;
